// FE-1 B0.b - fontes da marca AUTO-HOSPEDADAS via @fontsource.
// Manual v4.0 secao 9: Montserrat 700 nos titulos, Inter 400/600 no corpo.
// Os pesos 500 e 800 de Montserrat entram porque o manual os especifica para
// o logotipo ("STRONGERH" 800, "ONE" 500) caso ele venha a ser composto em
// texto; hoje o lockup e vetor, mas o custo de manter os pesos e marginal.
//
// NAO usar Google Fonts: a requisicao ao CDN vaza o IP do usuario para um
// terceiro a cada carregamento, o que conflita com a minimizacao de dado
// pessoal do ADR-0014. Auto-hospedar tambem remove um ponto de falha externo.
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/700.css'
import '@fontsource/montserrat/800.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/600.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { initTelemetry } from './telemetry/appInsights'

// ADR-0024 D10 - telemetria inicializada antes da primeira renderizacao para
// que erros de montagem tambem sejam capturados.
initTelemetry()

const rootElement = document.getElementById('root')
if (!rootElement) throw new Error('Elemento #root nao encontrado no index.html')

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
